export { default } from './Newsletter';